import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { A } from '@adornis/base/env-info.js';

export enum PartnerSchedulingImportRunStatus {
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

registerEnum({ enum: PartnerSchedulingImportRunStatus, name: 'PartnerSchedulingImportRunStatus' });

@Entity()
export class PartnerSchedulingImportRun extends MongoEntity {
  static override _class = 'PartnerSchedulingImportRun';
  static override _collectionName = 'partner-scheduling-import-runs';

  static override resolveID(_entity: PartnerSchedulingImportRun): string {
    return (_entity._id ??= A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(() => Date, { default: v => v ?? new Date() })
  importedAt: Maybe<Date>;

  @Field(() => String)
  sourceFilename: Maybe<string>;

  @Field(() => PartnerSchedulingImportRunStatus)
  status: PartnerSchedulingImportRunStatus = PartnerSchedulingImportRunStatus.RUNNING;

  @Field(() => Int, { default: v => v ?? 0 })
  clientsImported: Maybe<number>;

  @Field(() => Int, { default: v => v ?? 0 })
  partnersImported: Maybe<number>;

  @Field(() => [String], { default: v => v ?? [] })
  messages: Maybe<string[]>;
}
